export const magazineArticles = [
  {
    slug: 'felix-erste-kostprobe-quinoa-bowl',
    title: 'Felix\' erste Kostprobe: Die Hähnchen-Quinoa-Bowl',
    seoTitle: 'Felix probiert die Hähnchen-Quinoa-Bowl | Felix Genuss Magazin',
    metaDescription: 'Wie Felix unsere erste Hähnchen-Quinoa-Bowl bewertet hat: eine kleine Geschichte über Geduld, Hühnerduft und einen glücklichen Bolonka.',
    teaser: 'Ein wedelnder Schwanz, ein geduldiger Blick und ein leerer Napf: Felix\' erstes offizielles Testessen.',
    kategorie: 'Geschichten mit Felix',
    veroeffentlicht: '2026-07-08',
    geaendert: '2026-07-08',
    sections: [
      {
        h2: 'Der Moment der Wahrheit',
        paragraphs: [
          'Es gibt Augenblicke, in denen ein Bolonka Zwetna zur Statue wird. Für Felix ist das der Moment, in dem Hähnchen im Topf landet. Keine Bewegung, kein Mucks – nur ein sehr konzentrierter Blick in Richtung Herd.',
          'Unsere Hähnchen-Quinoa-Bowl war sein erstes offizielles Testessen für Felix Genuss. Die Regeln waren einfach: lauwarm servieren, nichts würzen, und Felix entscheidet selbst, ob sich ein zweiter Blick lohnt.',
        ],
      },
      {
        h2: 'Das Urteil',
        paragraphs: [
          'Das Urteil fiel eindeutig aus: Der Napf war leer, bevor wir das Foto für die Rezeptkarte fertig hatten. Besonders die weichen Karottenwürfel hatten es ihm angetan – die Quinoa wurde mit einer Gründlichkeit aufgespürt, die wir nur bewundern können.',
          'Was wir gelernt haben: Gutes Futter für Hunde braucht keine Tricks. Es braucht gute Zutaten, ein wenig Zeit und einen Feinschmecker, der ehrlich genug ist, den Napf zu verweigern, wenn etwas nicht stimmt. Genau dafür steht Felix Genuss.',
        ],
      },
    ],
  },
  {
    slug: 'willkommen-im-felix-genuss-magazin',
    title: 'Willkommen im Felix Genuss Magazin',
    seoTitle: 'Willkommen im Felix Genuss Magazin | Felix Genuss',
    metaDescription: 'Das Felix Genuss Magazin öffnet seine Türen: Was dich hier erwartet – Rezepte, Zutatenwissen, Tipps und Geschichten rund um Felix.',
    teaser: 'Unser Magazin öffnet seine Türen – mit Rezepten, Wissen und Geschichten aus Felix\' Welt.',
    kategorie: 'Hintergrund',
    veroeffentlicht: '2026-07-01',
    geaendert: '2026-07-01',
    sections: [
      {
        h2: 'Was dich hier erwartet',
        paragraphs: [
          'Felix Genuss ist aus einer einfachen Beobachtung entstanden: Auch kleine Hunde sind grosse Geniesser. In diesem Magazin teilen wir, was in Felix\' Küche entsteht – von saisonalen Rezepten über ehrliches Zutatenwissen bis zu kleinen Geschichten aus unserem Alltag.',
        ],
      },
      {
        h2: 'Unsere Themen',
        list: [
          'Rezepte mit sorgfältig ausgewählten Zutaten',
          'Zutatenwissen von A–Z, verständlich erklärt',
          'Praktische Tipps rund um Fütterung und Zubereitung',
          'Geschichten mit Felix, unserem Bolonka Zwetna',
          'Saisonale Beiträge und besondere Anlässe',
        ],
        paragraphs: [
          'Wir schreiben so, wie wir kochen: mit Sorgfalt, mit Freude und ohne leere Versprechen. Alles, was du hier liest, dient der Information und Inspiration – eine individuelle tierärztliche Beratung ersetzt es nicht. Schön, dass du da bist.',
        ],
      },
    ],
  },
];
